import { IPublicClientApplication } from '@azure/msal-browser';
import { Judge, Judgement, JudgementStatus } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  getAssignedJudge,
  getAssignedJudges,
  getCountryNominationJudgement,
  getCountryNominationJudgementCount,
  getJudgementStatus,
  getNominationJudgement,
  getNominationJudgementCount,
  insertAssignedJudge,
  updateAssignedJudge,
  updateCountryNominationJudgement,
  updateJudgementStatus,
  updateNominationJudgement,
} from './index';

export const createStaffNominationsJudgesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getAssignedJudge: (instance: IPublicClientApplication, nominationId: number, userId: number, countryId?: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAssignedJudge(fetchContext, nominationId, userId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAssignedJudge', isInFlight);
    },
  ),
  getAssignedJudges: (instance: IPublicClientApplication, nominationId: number, countryId?: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAssignedJudges(fetchContext, nominationId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAssignedJudges', isInFlight);
    },
  ),
  insertAssignedJudge: (instance: IPublicClientApplication, nominationId: number, judge: Judge, countryId?: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => insertAssignedJudge(fetchContext, nominationId, judge, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('insertAssignedJudge', isInFlight);
    },
  ),
  updateAssignedJudge: (instance: IPublicClientApplication, nominationId: number, userId: number, judge: Judge, countryId?: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateAssignedJudge(fetchContext, nominationId, userId, judge, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateAssignedJudge', isInFlight);
    },
  ),
  getJudgementStatus: (instance: IPublicClientApplication, nominationId: number, userId: number, countryId?: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getJudgementStatus(fetchContext, nominationId, userId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getJudgementStatus', isInFlight);
    },
  ),
  updateJudgementStatus: (instance: IPublicClientApplication, nominationId: number, userId: number, judgementStatus: JudgementStatus, countryId?: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateJudgementStatus(fetchContext, nominationId, userId, judgementStatus, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateJudgementStatus', isInFlight);
    },
  ),
  getNominationJudgement: (instance: IPublicClientApplication, nominationId: number, userId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getNominationJudgement(fetchContext, nominationId, userId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getNominationJudgement', isInFlight);
    },
  ),
  updateNominationJudgement: (instance: IPublicClientApplication, nominationId: number, userId: number, judgement: Judgement) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateNominationJudgement(fetchContext, nominationId, userId, judgement, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateNominationJudgement', isInFlight);
    },
  ),
  getNominationJudgementCount: (instance: IPublicClientApplication, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getNominationJudgementCount(fetchContext, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getNominationJudgementCount', isInFlight);
    },
  ),
  getCountryNominationJudgementCount: (instance: IPublicClientApplication, nominationId: number, countryId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCountryNominationJudgementCount(fetchContext, nominationId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCountryNominationJudgementCount', isInFlight);
    },
  ),
  getCountryNominationJudgement: (instance: IPublicClientApplication, nominationId: number, userId: number, countryId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCountryNominationJudgement(fetchContext, nominationId, userId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCountryNominationJudgement', isInFlight);
    },
  ),
  updateCountryNominationJudgement: (instance: IPublicClientApplication, nominationId: number, userId: number, judgement: Judgement, countryId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateCountryNominationJudgement(fetchContext, nominationId, userId, judgement, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateCountryNominationJudgement', isInFlight);
    },
  ),
});
